'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 22px;\n  margin-left: 5px;\n  min-width: 15px;\n  text-align: center;\n'], ['\n  font-size: 22px;\n  margin-left: 5px;\n  min-width: 15px;\n  text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  align-items: \'center\';\n  cursor: pointer;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  width: 47px;\n'], ['\n  align-items: \'center\';\n  cursor: pointer;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  width: 47px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  align-items: center;\n  background-color: rgba(\n    ', '\n  );\n  display: flex;\n  height: 100%;\n  max-width: 32px;\n  padding: 0 5px;\n  border-radius: 2px;\n  transition: all 0.5s ease;\n  &:hover {\n    background-color: rgba(\n      ', '\n    );\n  }\n  &:active {\n    background-color: rgba(\n      ', '\n    );\n  }\n  &.showingBadge {\n    padding: 0;\n    max-width: 100px;\n  }\n'], ['\n  align-items: center;\n  background-color: rgba(\n    ', '\n  );\n  display: flex;\n  height: 100%;\n  max-width: 32px;\n  padding: 0 5px;\n  border-radius: 2px;\n  transition: all 0.5s ease;\n  &:hover {\n    background-color: rgba(\n      ', '\n    );\n  }\n  &:active {\n    background-color: rgba(\n      ', '\n    );\n  }\n  &.showingBadge {\n    padding: 0;\n    max-width: 100px;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  & .unseen-threads-badge {\n    bottom: 3px;\n    position: relative;\n    right: 6px;\n  }\n'], ['\n  & .unseen-threads-badge {\n    bottom: 3px;\n    position: relative;\n    right: 6px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _icons = require('icons/icons');

var icons = _interopRequireWildcard(_icons);

var _UINotificationBadge = require('UIComponents/badge/UINotificationBadge');

var _UINotificationBadge2 = _interopRequireDefault(_UINotificationBadge);

var _color = require('../util/color');

var _WidgetHeaderButton = require('../WidgetHeaderButton');

var _WidgetHeaderButton2 = _interopRequireDefault(_WidgetHeaderButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ThreadButtonPlaceholder = _styledComponents2.default.div.withConfig({
  displayName: 'ShowThreadListButton__ThreadButtonPlaceholder'
})(_templateObject);

var ShowThreadButton = (0, _styledComponents2.default)(ThreadButtonPlaceholder).withConfig({
  displayName: 'ShowThreadListButton__ShowThreadButton'
})(_templateObject2);

var StyledButtonWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ShowThreadListButton__StyledButtonWrapper'
})(_templateObject3, function (_ref) {
  var activeBackgroundColor = _ref.activeBackgroundColor;
  return (0, _color.hexToRgba)(activeBackgroundColor, 0);
}, function (_ref2) {
  var activeBackgroundColor = _ref2.activeBackgroundColor;
  return (0, _color.hexToRgba)(activeBackgroundColor, 0.1);
}, function (_ref3) {
  var activeBackgroundColor = _ref3.activeBackgroundColor;
  return (0, _color.hexToRgba)(activeBackgroundColor, 0.4);
});

var StyledUINotificationBadge = (0, _styledComponents2.default)(_UINotificationBadge2.default).withConfig({
  displayName: 'ShowThreadListButton__StyledUINotificationBadge'
})(_templateObject4);

var ShowThreadListButton = function (_React$PureComponent) {
  _inherits(ShowThreadListButton, _React$PureComponent);

  function ShowThreadListButton() {
    _classCallCheck(this, ShowThreadListButton);

    return _possibleConstructorReturn(this, (ShowThreadListButton.__proto__ || Object.getPrototypeOf(ShowThreadListButton)).apply(this, arguments));
  }

  _createClass(ShowThreadListButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          activeBackgroundColor = _props.activeBackgroundColor,
          unseenThreadsCountExcludingCurrentThread = _props.unseenThreadsCountExcludingCurrentThread,
          showThreadList = _props.showThreadList,
          showThreadListButton = _props.showThreadListButton;


      if (!showThreadListButton) {
        return _react2.default.createElement(ThreadButtonPlaceholder, null);
      }
      var styledButtonWrapperClasses = (0, _classNames2.default)({
        showingBadge: !!unseenThreadsCountExcludingCurrentThread
      });

      return _react2.default.createElement(
        ShowThreadButton,
        { onClick: showThreadList },
        _react2.default.createElement(
          StyledButtonWrapper,
          {
            className: styledButtonWrapperClasses,
            activeBackgroundColor: activeBackgroundColor
          },
          _react2.default.createElement(
            StyledUINotificationBadge,
            {
              badgeClassName: 'unseen-threads-badge',
              className: 'show-threads-wrapper',
              placement: 'inline',
              badgeLabel: unseenThreadsCountExcludingCurrentThread,
              showBadge: !!unseenThreadsCountExcludingCurrentThread
            },
            _react2.default.createElement(_WidgetHeaderButton2.default, {
              className: 'selenium-test-marker-show-threads-button',
              ariaLabel: _I18n2.default.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.showThreadList', { unreadThreadCount: unseenThreadsCountExcludingCurrentThread }),
              iconName: icons.LEFT
            })
          )
        )
      );
    }
  }]);

  return ShowThreadListButton;
}(_react2.default.PureComponent);

ShowThreadListButton.propTypes = {
  activeBackgroundColor: _react.PropTypes.string.isRequired,
  showThreadList: _react.PropTypes.func.isRequired,
  showThreadListButton: _react.PropTypes.bool.isRequired,
  unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number.isRequired
};

ShowThreadListButton.defaultProps = {
  showThreadList: function showThreadList() {},
  showThreadListButton: false
};

exports.default = ShowThreadListButton;
module.exports = exports['default'];